<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolInventoryAndAssetsSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "School Assets",
                description: "Register school assets and maintain their details.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Store Management",
                description: "Manage school stores, stock locations, and supplies.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Inventory",
                description: "Track stock levels and monitor inventory movements.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Purchase Orders",
                description: "Create and track orders for school supplies and assets.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Suppliers",
                description: "Maintain supplier details and purchasing contacts.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Asset Maintenance",
                description: "Schedule and record maintenance for school assets.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
